import React, { useEffect, useState } from 'react';
import { groupSupplierDocuments } from 'features/supplier/utils';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';
import { toastSuccess } from '@components/Toast';

import SupplierDocumentUpload from '@features/supplier/component/SupplierDocumentUpload';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addSupplierAdditionalDocument } from '@services/supplierOnboardingService';

const AddSupportingDocuments = ({ onClose, documentResponseList, callBack, documentTypes }) => {
	const [groupedDocuments, setGroupedDocuments] = useState([]);
	const [uploadedData, setUploadedData] = useState({});
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		const tmpGroupDocuments = groupSupplierDocuments(documentResponseList, 'supportingDocumentType');
		setGroupedDocuments(tmpGroupDocuments);
	}, [documentResponseList]);

	const onChange = (data, fieldName, type) => {
		setUploadedData({
			...uploadedData,
			[fieldName]: { ...uploadedData[fieldName], [type]: data }
		});
	};

	const handleSubmit = async () => {
		dispatch(openLoader());
		let requestBody = Object.keys(uploadedData)
			.map((key) => {
				const documentDTO = uploadedData[key].documentDTO;
				if (!documentDTO) return null;
				return {
					supportingDocumentType: key,
					documentDTO: uploadedData[key].documentDTO,
					expiryDate: uploadedData[key].expiryDate || null
				};
			})
			.filter(Boolean);

		await addSupplierAdditionalDocument(id, requestBody);
		if (callBack) {
			await callBack();
		}
		toastSuccess('Updated successfully');
		dispatch(closeLoader());
		onClose();
	};

	const renderDocumentUpload = () => {
		return documentTypes?.map((item) => {
			let existingDocuments = groupedDocuments[item.id]?.map((existingDoc) => ({
				...existingDoc.documentResponse
			}));
			return (
				<React.Fragment key={`document_upload_${item.id}`}>
					<SupplierDocumentUpload
						title={item.value}
						fieldName={item.id}
						multiple={false}
						uploadType="SUPPORTING_DOCUMENT"
						callBack={callBack}
						documents={{ [item.id]: existingDocuments }}
						onChange={onChange}
					/>
				</React.Fragment>
			);
		});
	};

	return (
		<ModalContainer className="supplier-doucment-modal">
			<div className="common-popup">
				<ModalHeader title="Additional Information" onClose={onClose} />

				<div className="common-popup-body scroll-y-label">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="quick-info-files">{renderDocumentUpload()}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddSupportingDocuments;
